import axiosInstance from "../../../config/axios/axios.config";

export async function fetchUserCollections() {
  let url = "accounts/collections/user_collections/";
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    if (error?.flag === "WidgetError") {
      return null;
    }
    throw new Error(
      `Failed fetch data. fetchUserCustomizations with error: ${error}`
    );
  }
}
